import { TFunction } from 'i18next';
import { Message } from '../../../../interfaces/Message';
import { MessageDto } from '../../../../interfaces/dtos/MessageDto';
import transformMessages from '../transformMessages/transformMessages';
import transformAttachments from './transformAttachments/transformAttachments';
import transformSubject from './transformSubject/transformSubject';
import transformRecipients from './transformRecipients/transformRecipients';

export default function transformMessage(dto: MessageDto, t: TFunction<'DetailsLoader'>): Message {
  const message: Message = {
    content: dto.content,
    contractDescription: dto.contractDescription,
    businessLineDescription: dto.businessLineDescription,
    mainRecipient: transformRecipients(dto.recipients),
    anotherRecipient: transformRecipients(dto.recipients, true),
    previousMessages: transformMessages(dto.previousMessages, t),
    id: dto.id,
    messageSource: dto.messageSource,
    referenceNumber: dto.referenceNumber,
    activationDateUTC: dto.activationDateUTC,
    expirationDateUTC: dto.expirationDateUTC,
    freeTextSubject: dto.freeTextSubject,
    hasBeenReplied: dto.hasBeenReplied,
    isNew: dto.isNew,
    messageOriginId: dto.messageOriginId,
    replyFromMessageId: dto.replyFromMessageId,
    attachments: transformAttachments(dto.attachments),
    subjectDescription: transformSubject(t, dto.subjectDescription, dto.freeTextSubject),
    subjectGroupDescription: dto.subjectGroupDescription,
    subjectAssignmentName: dto.subjectAssignmentName,
    selected: false,
  };

  return message;
}
